import { A11yModule } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { UiAutofocusDirective, UiButtonComponent } from '@ui';
import { PersonGroupsModel } from '@models/person-groups.model';

@Component({
  selector: 'app-join-group-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    UiButtonComponent,
    A11yModule,
    UiAutofocusDirective,
  ],
  templateUrl: './join-group-dialog.component.html',
  styleUrl: './join-group-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JoinGroupDialogComponent implements OnInit {
  public readonly codeControl = new FormControl('', [Validators.required]);
  public readonly continueClicked = new Subject<string>();
  public titleKey = 'PERSON_GROUPS.JOIN_DIALOG.TITLE';
  public submitKey = 'PERSON_GROUPS.JOIN_DIALOG.SUBMIT';

  public constructor(
    private readonly dialogRef: MatDialogRef<JoinGroupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data?: PersonGroupsModel.JoinGroupDialogData,
  ) {}

  public ngOnInit(): void {
    if (this.data?.initialCode != null && this.data.initialCode !== '') {
      this.codeControl.setValue(this.data.initialCode);
    }
    if (this.data?.titleKey) {
      this.titleKey = this.data.titleKey;
    }
    if (this.data?.submitKey) {
      this.submitKey = this.data.submitKey;
    }
  }

  public onContinue(): void {
    const code = this.codeControl.value?.trim();
    if (!code) {
      return;
    }
    this.continueClicked.next(code);
  }

  public onCancel(): void {
    this.dialogRef.close(null);
  }
}
